'use strict';

var React = require('react');
var component = require('../../forms/Switch/component.js');
var cell = require('./cell.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const CellSwitch = ({ checked, onChange, switchProps, ...props }) => (React__default.default.createElement(cell.Cell, { noEllipsis: true, ...props },
    React__default.default.createElement(component.Switch, { checked: checked, onFocus: e => e.stopPropagation(), onChange: onChange, ...switchProps })));

exports.CellSwitch = CellSwitch;
//# sourceMappingURL=cellSwitch.js.map
